import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
// import './menu2.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import "./firebase/config";

//const root = ReactDOM.createRoot(document.getElementById('root'));
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    {/* <Router basename={process.env.PUBLIC_URL}> */}

    {/* <BrowserRouter basename={process.env.PUBLIC_URL}> */}
    <BrowserRouter basename="avionica2">
    {/* <BrowserRouter basename={window.location.pathname.replace(/(\/[^/]+)$/, "")}>  */}
    {/* <BrowserRouter> */}
    <App />
    </BrowserRouter>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
